import type React from 'react';
import type { ReactElement } from 'react';
import { connect } from 'react-redux';

import { debounce } from 'shared/util/debounce';
import { fetchHotelResultsToAppend } from '../../state/hotelResultActions';

import { ApiActionStatus, type ApiQueryParams, type HotelResults, type PaleState } from '../../interfaces';

interface HotelPaginationProps {
    hotelResults: HotelResults;
    triggerFetch: (queryParam?: ApiQueryParams) => void;
}

export const HotelPagination: React.FC<HotelPaginationProps> = ({ triggerFetch, hotelResults }): ReactElement<HotelPaginationProps> => {
    const offersLeft = hotelResults.numberOfOffers - hotelResults.offers.length;

    const fetchMoreOffers = debounce((): void => {
        const nextPage: string = (hotelResults.currentPage + 1).toString();
        if (hotelResults.currentPage + 1 <= hotelResults.totalPages) {
            triggerFetch({ page: nextPage });
        }
    }, 200);

    return (
        <div className="u-text-center u-mb64">
            {offersLeft > 0 ? (
                <button
                    type="button"
                    data-testid="hotel-pagination-button"
                    className="button button--flat"
                    onClick={(): void => fetchMoreOffers()}
                    disabled={hotelResults.status === ApiActionStatus.PENDING}>
                    Last inn {Math.min(12, offersLeft)} av {offersLeft} flere tilbud
                </button>
            ) : null}
        </div>
    );
};

const mapStateToProps = ({ hotelResults }: PaleState): Pick<HotelPaginationProps, 'hotelResults'> => ({ hotelResults });

const mapDispatchToProps = { triggerFetch: fetchHotelResultsToAppend };

export default connect(mapStateToProps, mapDispatchToProps)(HotelPagination);
